import { Injectable } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { TitleService } from './title.service';
import { RestApiService } from './rest-api.service';
declare var UIkit: any;

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  /*========================================
                  Variables
  =========================================*/

  alerts: Array<any> = []; // replace by Alert interface when available
  carAlertCount: number = 0;
  userAlertCount: number = 0;
  reservationAlertCount: number = 0;
  alertCount: number = 0;
  alertLoading: boolean = false;
  alertCountLoading: boolean = false;
  serviceInitialized: boolean = false;

  private subscription: Subscription; 

  constructor(
    private titleService: TitleService,
    private api: RestApiService
  ) {}

  initializeService() {
    if (this.serviceInitialized === true)
      return;
    this.serviceInitialized = true;
    this.updateAlertCount(true);
    
    /* Retrieve alerts every 3 minutes */
    this.subscription = interval(3000 * 60).subscribe(x => {
      this.updateAlertCount();
    });
  }

  killService() {
    if (this.serviceInitialized === false)
      return;
    this.subscription.unsubscribe();
    this.alerts = [];
    this.carAlertCount = 0;
    this.userAlertCount = 0;
    this.reservationAlertCount = 0;
    this.alertCount = 0;
    this.alertLoading = false;
    this.alertCountLoading = false;
    this.serviceInitialized = false;
  }

  /*========================================
              Configure service
  =========================================*/

  addAlert() : void { };
  removeAlert() : void { };
  updateAlert() : void { };
  getAlertCount() : number { return this.alertCount; };
  setAlertCount(alertCount) : void { this.alertCount = alertCount; };

  /*========================================
                   Methods
  =========================================*/

  updateAlertCount(toast?) : void {
    let count = 0;

    this.alertCountLoading = true;
    this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/state-of-car/alert', {}).then((res) => {
      if (typeof res === "number") {
        this.carAlertCount = res;
        count += res;
      }
      this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/booking/alert', {}).then((res) => {
        if (typeof res === "number") {
          this.reservationAlertCount = res;
          count += res;
        }
        this.api.get('/MI_Galago/WCF_MI_Galago/REST/vop/user/alert', {}).then((res) => {
          if (typeof res === "number") {
            this.userAlertCount = res;
            count += res;
          }
          this.alertCount = count;
          this.titleService.setNotificationCount(this.alertCount);
          this.alertCountLoading = false;
          if (toast === true) {
            this.alert("Vous avez " + this.alertCount + " alertes");
          }
        });
      });
    });
  };

  updateAlerts(toast?) : void { 
    this.alertLoading = true;
    /* Call API to retrieve alerts */
    this.alertLoading = false;
  };

  alert(content) : any {
    return UIkit.notification("<div style='margin-right: 20px'></div><span class='uk-text-uppercase uk-text-small'>" + content + "</span>", {pos: 'top-right', timeout: 5000});
  }

  loading() : any {
    return UIkit.notification("<div uk-spinner style='margin-right: 20px'></div><span class='uk-text-uppercase uk-text-small'>Chargement</span>", {pos: 'top-right', timeout: 5000});
  }

  error(content) : any {
    return UIkit.notification("<div style='margin-right: 20px;'></div><span class='uk-text-uppercase uk-text-small'>" + content + "</span>", {pos: 'top-right', timeout: 5000, status: 'danger'});
  }

}
